/**
 * Parse an ISO-8601 date string to a Date object, correcting for timezone issues.
 * See this detailed post https://stackoverflow.com/a/31732581/2158167 for more details on how this works to preserve a date after parse across timezones.
 */
export const parseIsoDateStringToDateCorrectTz = (isoDateString: string): Date => {
  return new Date(isoDateString.replace(/-/g, '/').replace(/T.+/, ''));
};
